import { __decorate, __awaiter } from 'tslib';
import { ɵɵdefineInjectable, Injectable, Component, EventEmitter, ViewChild, Input, Output, InjectionToken, NgModule } from '@angular/core';
import { Subject } from 'rxjs';
import { AngularFirestore, AngularFirestoreModule } from '@angular/fire/firestore';
import { takeUntil, tap, finalize } from 'rxjs/operators';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FlexLayoutModule } from '@angular/flex-layout';
import { AngularFireStorage, AngularFireStorageModule } from '@angular/fire/storage';
import { FirebaseOptionsToken, FirebaseNameOrConfigToken } from '@angular/fire';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatRippleModule } from '@angular/material/core';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/fire/firestore';
import * as ɵngcc2 from '@angular/material/button';
import * as ɵngcc3 from '@angular/material/tooltip';
import * as ɵngcc4 from '@angular/material/icon';
import * as ɵngcc5 from '@angular/common';
import * as ɵngcc6 from '@angular/material/core';
import * as ɵngcc7 from '@angular/flex-layout/flex';
import * as ɵngcc8 from '@angular/fire/storage';
import * as ɵngcc9 from '@angular/material/progress-spinner';

const _c0 = ["fileInput"];
function NgxStorageFirebaseuiImagesComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "ngx-storage-firebaseui-images-uploader", 6);
    ɵngcc0.ɵɵlistener("onImageUploaded", function NgxStorageFirebaseuiImagesComponent_div_6_Template_ngx_storage_firebaseui_images_uploader_onImageUploaded_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.onImageUploaded.emit($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const file_r3 = ctx.$implicit;
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("file", file_r3)("path", ctx_r1.path);
} }
function NgxStorageFirebaseuiImagesComponent_div_7_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵelementStart(1, "button", 11);
    ɵngcc0.ɵɵlistener("click", function NgxStorageFirebaseuiImagesComponent_div_7_div_3_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r11); const i_r7 = ɵngcc0.ɵɵnextContext().index; const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.deleteImage(i_r7); });
    ɵngcc0.ɵɵelementStart(2, "mat-icon");
    ɵngcc0.ɵɵtext(3, "delete");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function NgxStorageFirebaseuiImagesComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "button", 7);
    ɵngcc0.ɵɵlistener("click", function NgxStorageFirebaseuiImagesComponent_div_7_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r13); const i_r7 = ctx.index; const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.onImageSelectedAtIndex.emit(i_r7); });
    ɵngcc0.ɵɵelement(2, "span", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, NgxStorageFirebaseuiImagesComponent_div_7_div_3_Template, 4, 0, "div", 9);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r6 = ctx.$implicit;
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵstyleProp("background-image", "url(" + item_r6.downloadURL + ")", ɵngcc0.ɵɵdefaultStyleSanitizer);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.editMode);
} }
function NgxStorageFirebaseuiImagesUploaderComponent_div_0_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 5);
} if (rf & 2) {
    const ctx_r16 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵstyleProp("background-image", "url(" + ctx_r16.downloadURL + ")", ɵngcc0.ɵɵdefaultStyleSanitizer);
} }
function NgxStorageFirebaseuiImagesUploaderComponent_div_0_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 6);
    ɵngcc0.ɵɵelementStart(1, "span", 7);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "number");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(4, "mat-progress-spinner", 8);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const pct_r19 = ctx.ngIf;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(3, 2, pct_r19), "%");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("value", pct_r19);
} }
function NgxStorageFirebaseuiImagesUploaderComponent_div_0_div_5_button_5_Template(rf, ctx) { if (rf & 1) {
    const _r23 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 15);
    ɵngcc0.ɵɵlistener("click", function NgxStorageFirebaseuiImagesUploaderComponent_div_0_div_5_button_5_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r23); const ctx_r22 = ɵngcc0.ɵɵnextContext(3); return ctx_r22.task.pause(); });
    ɵngcc0.ɵɵelementStart(1, "mat-icon");
    ɵngcc0.ɵɵtext(2, "pause");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function NgxStorageFirebaseuiImagesUploaderComponent_div_0_div_5_button_6_Template(rf, ctx) { if (rf & 1) {
    const _r25 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 16);
    ɵngcc0.ɵɵlistener("click", function NgxStorageFirebaseuiImagesUploaderComponent_div_0_div_5_button_6_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r25); const ctx_r24 = ɵngcc0.ɵɵnextContext(3); return ctx_r24.task.resume(); });
    ɵngcc0.ɵɵelementStart(1, "mat-icon");
    ɵngcc0.ɵɵtext(2, "play_arrow");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function NgxStorageFirebaseuiImagesUploaderComponent_div_0_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r27 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 9);
    ɵngcc0.ɵɵelementStart(1, "div", 10);
    ɵngcc0.ɵɵelementStart(2, "button", 11);
    ɵngcc0.ɵɵlistener("click", function NgxStorageFirebaseuiImagesUploaderComponent_div_0_div_5_Template_button_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r27); const ctx_r26 = ɵngcc0.ɵɵnextContext(2); return ctx_r26.task.cancel(); });
    ɵngcc0.ɵɵelementStart(3, "mat-icon");
    ɵngcc0.ɵɵtext(4, "close");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(5, NgxStorageFirebaseuiImagesUploaderComponent_div_0_div_5_button_5_Template, 3, 0, "button", 12);
    ɵngcc0.ɵɵtemplate(6, NgxStorageFirebaseuiImagesUploaderComponent_div_0_div_5_button_6_Template, 3, 0, "button", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "span", 14);
    ɵngcc0.ɵɵtext(8, "1mb");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const snap_r15 = ɵngcc0.ɵɵnextContext().ngIf;
    const ctx_r18 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("disabled", !ctx_r18.isActive(snap_r15));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r18.isActive(snap_r15));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (snap_r15 == null ? null : snap_r15.state) === "paused");
} }
function NgxStorageFirebaseuiImagesUploaderComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "button", 1);
    ɵngcc0.ɵɵtemplate(2, NgxStorageFirebaseuiImagesUploaderComponent_div_0_span_2_Template, 1, 2, "span", 2);
    ɵngcc0.ɵɵtemplate(3, NgxStorageFirebaseuiImagesUploaderComponent_div_0_span_3_Template, 5, 4, "span", 3);
    ɵngcc0.ɵɵpipe(4, "async");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(5, NgxStorageFirebaseuiImagesUploaderComponent_div_0_div_5_Template, 9, 3, "div", 4);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("disabled", true);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r14.downloadURL);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(4, 4, !ctx_r14.downloadURL && ctx_r14.percentage));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r14.downloadURL);
} }
let NgxStorageFirebaseuiService = class NgxStorageFirebaseuiService {
    constructor() {
    }
};
NgxStorageFirebaseuiService.ɵfac = function NgxStorageFirebaseuiService_Factory(t) { return new (t || NgxStorageFirebaseuiService)(); };
NgxStorageFirebaseuiService.ɵprov = ɵɵdefineInjectable({ factory: function NgxStorageFirebaseuiService_Factory() { return new NgxStorageFirebaseuiService(); }, token: NgxStorageFirebaseuiService, providedIn: "root" });

let NgxStorageFirebaseuiComponent = class NgxStorageFirebaseuiComponent {
    constructor() {
    }
    ngOnInit() {
    }
};
NgxStorageFirebaseuiComponent.ɵfac = function NgxStorageFirebaseuiComponent_Factory(t) { return new (t || NgxStorageFirebaseuiComponent)(); };
NgxStorageFirebaseuiComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: NgxStorageFirebaseuiComponent, selectors: [["lib-ngx-storage-firebaseui"]], decls: 2, vars: 0, template: function NgxStorageFirebaseuiComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "p");
        ɵngcc0.ɵɵtext(1, " ngx-storage-firebaseui works! ");
        ɵngcc0.ɵɵelementEnd();
    } }, encapsulation: 2 });

let NgxStorageFirebaseuiImagesComponent = class NgxStorageFirebaseuiImagesComponent {
    constructor(db) {
        this.db = db;
        this.load = true;
        this.addButtonTooltipText = 'add picture';
        // tslint:disable-next-line:no-output-on-prefix
        this.onLoad = new EventEmitter();
        // tslint:disable-next-line:no-output-on-prefix
        this.onImageUploaded = new EventEmitter();
        // tslint:disable-next-line:no-output-on-prefix
        this.onImageSelectedAtIndex = new EventEmitter();
        this.files = [];
        this.images = [];
        // Set the private defaults
        this.unsubscribeAll = new Subject();
    }
    ngOnInit() {
        if (this.load) {
            this.loadImages();
        }
    }
    link() {
        this.fileInput.nativeElement.click();
    }
    onDrop(files) {
        for (let i = 0; i < files.length; i++) {
            this.files.push(files.item(i));
        }
    }
    loadImages() {
        this.getCollectionRef(this.path)
            .valueChanges()
            .pipe(takeUntil(this.unsubscribeAll))
            .subscribe((imgs) => {
            this.onLoad.emit(imgs);
            this.images = imgs;
            console.log('imgs', imgs);
        });
    }
    getCollectionRef(path, queryFn) {
        return this.db.collection(`${path}`, queryFn);
    }
    deleteImage(i) {
        console.log('delete image at index', i);
    }
};
NgxStorageFirebaseuiImagesComponent.ɵfac = function NgxStorageFirebaseuiImagesComponent_Factory(t) { return new (t || NgxStorageFirebaseuiImagesComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.AngularFirestore)); };
NgxStorageFirebaseuiImagesComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: NgxStorageFirebaseuiImagesComponent, selectors: [["ngx-storage-firebaseui-images"]], viewQuery: function NgxStorageFirebaseuiImagesComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.fileInput = _t.first);
    } }, inputs: { load: "load", addButtonTooltipText: "addButtonTooltipText", path: "path" }, outputs: { onLoad: "onLoad", onImageUploaded: "onImageUploaded", onImageSelectedAtIndex: "onImageSelectedAtIndex" }, decls: 8, vars: 4, consts: [[1, "grid"], ["accept", "image/*", "id", "fileInput", "multiple", "", "name", "file", "type", "file", 3, "hidden", "change"], ["fileInput", ""], ["mat-raised-button", "", 1, "grid-item", 3, "matTooltip", "click"], ["color", "accent", 2, "transform", "scale(3)"], [4, "ngFor", "ngForOf"], [3, "file", "path", "onImageUploaded"], ["gallery", "lightbox", "mat-raised-button", "", "mat-ripple", "", 1, "grid-item", 3, "click"], [1, "grid-image"], ["fxLayout", "row", "fxLayoutAlign", "center", "fxLayoutGap", "5px", 4, "ngIf"], ["fxLayout", "row", "fxLayoutAlign", "center", "fxLayoutGap", "5px"], ["color", "warn", "mat-mini-fab", "", "matTooltip", "L\u00F6schen", 3, "click"]], template: function NgxStorageFirebaseuiImagesComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "input", 1, 2);
        ɵngcc0.ɵɵlistener("change", function NgxStorageFirebaseuiImagesComponent_Template_input_change_1_listener($event) { return ctx.onDrop($event.target.files); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "button", 3);
        ɵngcc0.ɵɵlistener("click", function NgxStorageFirebaseuiImagesComponent_Template_button_click_3_listener() { return ctx.link(); });
        ɵngcc0.ɵɵelementStart(4, "mat-icon", 4);
        ɵngcc0.ɵɵtext(5, "add");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(6, NgxStorageFirebaseuiImagesComponent_div_6_Template, 2, 2, "div", 5);
        ɵngcc0.ɵɵtemplate(7, NgxStorageFirebaseuiImagesComponent_div_7_Template, 4, 3, "div", 5);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", true);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("matTooltip", ctx.addButtonTooltipText);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.files);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.images);
    } }, directives: function () { return [ɵngcc2.MatButton, ɵngcc3.MatTooltip, ɵngcc4.MatIcon, ɵngcc5.NgForOf, NgxStorageFirebaseuiImagesUploaderComponent, ɵngcc6.MatRipple, ɵngcc5.NgIf, ɵngcc7.DefaultLayoutDirective, ɵngcc7.DefaultLayoutAlignDirective, ɵngcc7.DefaultLayoutGapDirective]; }, styles: ["[_nghost-%COMP%]{width:100%}.grid-item[_ngcontent-%COMP%]{margin:1em;border-radius:.2em;overflow:hidden;padding:0;width:200px;height:140px}@media only screen and (max-width:480px){.grid-item[_ngcontent-%COMP%]{margin:.4em;width:100px;height:80px}}.grid[_ngcontent-%COMP%]{display:flex;justify-content:center;align-items:center;flex-wrap:wrap;margin:3em 0}.grid-image[_ngcontent-%COMP%]{display:block;width:100%;height:100%;background-size:cover;background-position:center center}.percentage[_ngcontent-%COMP%]{margin:0 -50% 0 0;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);font-size:24px}"] });
NgxStorageFirebaseuiImagesComponent.ctorParameters = () => [
    { type: AngularFirestore }
];
__decorate([
    ViewChild('fileInput', { static: false })
], NgxStorageFirebaseuiImagesComponent.prototype, "fileInput", void 0);
__decorate([
    Input()
], NgxStorageFirebaseuiImagesComponent.prototype, "path", void 0);
__decorate([
    Input()
], NgxStorageFirebaseuiImagesComponent.prototype, "load", void 0);
__decorate([
    Input()
], NgxStorageFirebaseuiImagesComponent.prototype, "addButtonTooltipText", void 0);
__decorate([
    Output()
], NgxStorageFirebaseuiImagesComponent.prototype, "onLoad", void 0);
__decorate([
    Output()
], NgxStorageFirebaseuiImagesComponent.prototype, "onImageUploaded", void 0);
__decorate([
    Output()
], NgxStorageFirebaseuiImagesComponent.prototype, "onImageSelectedAtIndex", void 0);

// This token is the official token containing the final configuration; ie. the merge between default and user provided configurations
const NgxStorageFirebaseUIConfigToken = new InjectionToken('NgxStorageFirebaseUIConfigToken');

let NgxStorageFirebaseuiImagesUploaderComponent = class NgxStorageFirebaseuiImagesUploaderComponent {
    constructor(storage, db) {
        this.storage = storage;
        this.db = db;
        // tslint:disable-next-line:no-output-on-prefix
        this.onImageUploaded = new EventEmitter();
    }
    ngOnInit() {
        this.startUpload();
    }
    startUpload() {
        this.id = this.db.createId();
        // The storage path
        // const path = `test/${Date.now()}_${this.file.name}`;
        const path = `${this.path}/${this.id}/${Date.now()}_${this.file.name}`;
        // Reference to storage bucket
        const ref = this.storage.ref(path);
        // The main task
        this.task = this.storage.upload(path, this.file);
        // Progress monitoring
        this.percentage = this.task.percentageChanges();
        this.snapshot = this.task.snapshotChanges().pipe(tap(console.log), 
        // The file's download URL
        finalize(() => __awaiter(this, void 0, void 0, function* () {
            this.downloadURL = yield ref.getDownloadURL().toPromise();
            const image = { id: this.id, downloadURL: this.downloadURL, path };
            this.onImageUploaded.emit(image);
            const pathSegments = path.split('/');
            pathSegments.pop();
            this.db.doc(pathSegments.join('/')).set({ downloadURL: this.downloadURL, path }, { merge: true });
        })));
    }
    isActive(snapshot) {
        return snapshot.state === 'running' && snapshot.bytesTransferred < snapshot.totalBytes;
    }
};
NgxStorageFirebaseuiImagesUploaderComponent.ɵfac = function NgxStorageFirebaseuiImagesUploaderComponent_Factory(t) { return new (t || NgxStorageFirebaseuiImagesUploaderComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc8.AngularFireStorage), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.AngularFirestore)); };
NgxStorageFirebaseuiImagesUploaderComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: NgxStorageFirebaseuiImagesUploaderComponent, selectors: [["ngx-storage-firebaseui-images-uploader"]], inputs: { path: "path", file: "file" }, outputs: { onImageUploaded: "onImageUploaded" }, decls: 2, vars: 3, consts: [[4, "ngIf"], ["mat-raised-button", "", "mat-ripple", "", 1, "grid-item", 3, "disabled"], ["class", "grid-image", 3, "backgroundImage", 4, "ngIf"], ["fxFlexAlign", "center center", 4, "ngIf"], ["fxLayout", "row", "fxLayoutAlign", "space-between center", "fxLayoutGap", "5px", "style", "margin-left: 1rem; margin-right: 1rem", 4, "ngIf"], [1, "grid-image"], ["fxFlexAlign", "center center"], ["fxFlexAlign", "center center", 1, "percentage"], ["color", "accent", "mode", "determinate", 2, "margin", "0 auto", 3, "value"], ["fxLayout", "row", "fxLayoutAlign", "space-between center", "fxLayoutGap", "5px", 2, "margin-left", "1rem", "margin-right", "1rem"], ["fxLayout", "row", "fxLayoutGap", "5px"], ["color", "warn", "mat-mini-fab", "", "matTooltip", "abbrechen", 3, "disabled", "click"], ["color", "primary", "mat-mini-fab", "", 3, "click", 4, "ngIf"], ["color", "accent", "mat-mini-fab", "", 3, "click", 4, "ngIf"], ["mat-card-subtitle", "", 1, "text-truncate"], ["color", "primary", "mat-mini-fab", "", 3, "click"], ["color", "accent", "mat-mini-fab", "", 3, "click"]], template: function NgxStorageFirebaseuiImagesUploaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, NgxStorageFirebaseuiImagesUploaderComponent_div_0_Template, 6, 6, "div", 0);
        ɵngcc0.ɵɵpipe(1, "async");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(1, 1, ctx.snapshot));
    } }, directives: [ɵngcc5.NgIf, ɵngcc2.MatButton, ɵngcc6.MatRipple, ɵngcc7.DefaultFlexAlignDirective, ɵngcc9.MatProgressSpinner, ɵngcc7.DefaultLayoutDirective, ɵngcc7.DefaultLayoutAlignDirective, ɵngcc7.DefaultLayoutGapDirective, ɵngcc3.MatTooltip, ɵngcc4.MatIcon], pipes: [ɵngcc5.AsyncPipe, ɵngcc5.DecimalPipe], styles: [""] });
NgxStorageFirebaseuiImagesUploaderComponent.ctorParameters = () => [
    { type: AngularFireStorage },
    { type: AngularFirestore }
];
__decorate([
    Input()
], NgxStorageFirebaseuiImagesUploaderComponent.prototype, "path", void 0);
__decorate([
    Input()
], NgxStorageFirebaseuiImagesUploaderComponent.prototype, "file", void 0);
__decorate([
    Output()
], NgxStorageFirebaseuiImagesUploaderComponent.prototype, "onImageUploaded", void 0);

var NgxStorageFirebaseuiModule_1;
let NgxStorageFirebaseuiModule = NgxStorageFirebaseuiModule_1 = class NgxStorageFirebaseuiModule {
    static forRoot(configFactory, appNameFactory = () => undefined, config = {}) {
        return {
            ngModule: NgxStorageFirebaseuiModule_1,
            providers: [
                {
                    provide: FirebaseOptionsToken,
                    useValue: configFactory
                },
                {
                    provide: FirebaseNameOrConfigToken,
                    useFactory: appNameFactory
                },
                { provide: NgxStorageFirebaseUIConfigToken, useValue: config }
            ]
        };
    }
};
NgxStorageFirebaseuiModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: NgxStorageFirebaseuiModule });
NgxStorageFirebaseuiModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function NgxStorageFirebaseuiModule_Factory(t) { return new (t || NgxStorageFirebaseuiModule)(); }, imports: [[
            CommonModule,
            // Firebase
            AngularFirestoreModule,
            AngularFireStorageModule,
            // Material
            MatButtonModule,
            MatIconModule,
            MatProgressSpinnerModule,
            MatTooltipModule,
            MatRippleModule,
            // FLEX_LAYOUT
            FlexLayoutModule,
        ]] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NgxStorageFirebaseuiService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NgxStorageFirebaseuiComponent, [{
        type: Component,
        args: [{
                selector: 'lib-ngx-storage-firebaseui',
                template: `
    <p>
      ngx-storage-firebaseui works!
    </p>
  `
            }]
    }], function () { return []; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NgxStorageFirebaseuiImagesComponent, [{
        type: Component,
        args: [{
                selector: 'ngx-storage-firebaseui-images',
                template: "<div class=\"grid\">\n  <input #fileInput\n         (change)=\"onDrop($event.target.files)\"\n         [hidden]=\"true\"\n         accept=\"image/*\"\n         id=\"fileInput\"\n         multiple\n         name=\"file\"\n         type=\"file\">\n  <button (click)=\"link()\" [matTooltip]=\"addButtonTooltipText\" class=\"grid-item\" mat-raised-button>\n    <mat-icon color=\"accent\" style=\"transform: scale(3)\">add</mat-icon>\n  </button>\n\n  <div *ngFor=\"let file of files\">\n    <ngx-storage-firebaseui-images-uploader (onImageUploaded)=\"onImageUploaded.emit($event)\"\n                                            [file]=\"file\"\n                                            [path]=\"path\">\n    </ngx-storage-firebaseui-images-uploader>\n  </div>\n\n  <div *ngFor=\"let item of images ; let i = index\">\n    <button class=\"grid-item\" gallery=\"lightbox\"\n            (click)=\"onImageSelectedAtIndex.emit(i)\" mat-raised-button\n            mat-ripple>\n\n      <span [style.backgroundImage]=\"'url(' + item.downloadURL + ')'\" class=\"grid-image\"></span>\n    </button>\n    <div *ngIf=\"editMode\" fxLayout=\"row\" fxLayoutAlign=\"center\" fxLayoutGap=\"5px\">\n      <button (click)=\"deleteImage(i)\" color=\"warn\" mat-mini-fab matTooltip=\"L\u00F6schen\">\n        <mat-icon>delete</mat-icon>\n      </button>\n    </div>\n  </div>\n</div>\n",
                styles: [":host{width:100%}.grid-item{margin:1em;border-radius:.2em;overflow:hidden;padding:0;width:200px;height:140px}@media only screen and (max-width:480px){.grid-item{margin:.4em;width:100px;height:80px}}.grid{display:flex;justify-content:center;align-items:center;flex-wrap:wrap;margin:3em 0}.grid-image{display:block;width:100%;height:100%;background-size:cover;background-position:center center}.percentage{margin:0 -50% 0 0;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);font-size:24px}"]
            }]
    }], function () { return [{ type: ɵngcc1.AngularFirestore }]; }, { load: [{
            type: Input
        }], addButtonTooltipText: [{
            type: Input
        }], onLoad: [{
            type: Output
        }], onImageUploaded: [{
            type: Output
        }], onImageSelectedAtIndex: [{
            type: Output
        }], fileInput: [{
            type: ViewChild,
            args: ['fileInput', { static: false }]
        }], path: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NgxStorageFirebaseuiImagesUploaderComponent, [{
        type: Component,
        args: [{
                selector: 'ngx-storage-firebaseui-images-uploader',
                template: "<div *ngIf=\"(snapshot | async) as snap\">\n  <button [disabled]=\"true\"\n          class=\"grid-item\" mat-raised-button mat-ripple>\n    <span *ngIf=\"downloadURL\"\n          [style.backgroundImage]=\"'url(' + downloadURL+ ')'\"\n          class=\"grid-image\">\n    </span>\n    <span *ngIf=\"!downloadURL && percentage | async as pct\" fxFlexAlign=\"center center\">\n      <span class=\"percentage\" fxFlexAlign=\"center center\">{{ pct | number }}%</span>\n      <mat-progress-spinner\n        [value]=\"pct\"\n        color=\"accent\"\n        mode=\"determinate\"\n        style=\"margin:0 auto;\">\n    </mat-progress-spinner>\n    </span>\n  </button>\n  <div *ngIf=\"!downloadURL\"\n       fxLayout=\"row\"\n       fxLayoutAlign=\"space-between center\"\n       fxLayoutGap=\"5px\"\n       style=\"margin-left: 1rem; margin-right: 1rem\">\n    <div fxLayout=\"row\" fxLayoutGap=\"5px\">\n      <button (click)=\"task.cancel()\" [disabled]=\"!isActive(snap)\" color=\"warn\"\n              mat-mini-fab\n              matTooltip=\"abbrechen\">\n        <mat-icon>close</mat-icon>\n      </button>\n      <button (click)=\"task.pause()\" *ngIf=\"isActive(snap)\" color=\"primary\" mat-mini-fab>\n        <mat-icon>pause</mat-icon>\n      </button>\n      <button (click)=\"task.resume()\" *ngIf=\"snap?.state === 'paused'\" color=\"accent\" mat-mini-fab>\n        <mat-icon>play_arrow</mat-icon>\n      </button>\n    </div>\n    <span class=\"text-truncate\" mat-card-subtitle>1mb</span>\n  </div>\n</div>\n",
                styles: [""]
            }]
    }], function () { return [{ type: ɵngcc8.AngularFireStorage }, { type: ɵngcc1.AngularFirestore }]; }, { onImageUploaded: [{
            type: Output
        }], path: [{
            type: Input
        }], file: [{
            type: Input
        }] }); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxStorageFirebaseuiModule, { declarations: function () { return [NgxStorageFirebaseuiComponent,
        NgxStorageFirebaseuiImagesComponent,
        NgxStorageFirebaseuiImagesUploaderComponent]; }, imports: function () { return [CommonModule,
        // Firebase
        AngularFirestoreModule,
        AngularFireStorageModule,
        // Material
        MatButtonModule,
        MatIconModule,
        MatProgressSpinnerModule,
        MatTooltipModule,
        MatRippleModule,
        // FLEX_LAYOUT
        FlexLayoutModule]; }, exports: function () { return [NgxStorageFirebaseuiComponent,
        NgxStorageFirebaseuiImagesComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NgxStorageFirebaseuiModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    NgxStorageFirebaseuiComponent,
                    NgxStorageFirebaseuiImagesComponent,
                    NgxStorageFirebaseuiImagesUploaderComponent
                ],
                imports: [
                    CommonModule,
                    // Firebase
                    AngularFirestoreModule,
                    AngularFireStorageModule,
                    // Material
                    MatButtonModule,
                    MatIconModule,
                    MatProgressSpinnerModule,
                    MatTooltipModule,
                    MatRippleModule,
                    // FLEX_LAYOUT
                    FlexLayoutModule,
                ],
                exports: [NgxStorageFirebaseuiComponent, NgxStorageFirebaseuiImagesComponent]
            }]
    }], null, null); })();

// import * as firebase from 'firebase';
const defaultStorageFirebaseUIConfig = {
    // authMethod: 'redirect',
    // authProviders: [new GoogleAuthProvider(), new FacebookAuthProvider(), new TwitterAuthProvider(), new GithubAuthProvider()],
    enableFirestoreSync: true,
    // Default to email verification on
    enableEmailVerification: true
};

/*
 * Public API Surface of ngx-storage-firebaseui
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgxStorageFirebaseUIConfigToken, NgxStorageFirebaseuiComponent, NgxStorageFirebaseuiImagesComponent, NgxStorageFirebaseuiImagesUploaderComponent, NgxStorageFirebaseuiModule, NgxStorageFirebaseuiService, defaultStorageFirebaseUIConfig };

//# sourceMappingURL=ngx-storage-firebaseui.js.map